import { ExpenseResponseDto } from "../shared/dtos/expense/ExpenseResponseDto";
import { ExpenseSummaryDto } from "../shared/dtos/expense/ExpenseSummaryDto";

export class ExpenseMapper {
  public static mapToSummary(expense: ExpenseResponseDto): ExpenseSummaryDto {
    return {
      id: expense.id,
      category: expense.categoryName,
      amount: expense.amount,
      description: expense.description,
      processedBy: expense.processedBy,
    };
  }
}
